module.exports = __webpack_public_path__ + "static/media/no-restarts.f523b395.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/pages/home/sections/marketingPoints/assets/no-restarts.png
 ** module id = 571
 ** module chunks = 0
 **/